import { useState } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import { CheckCircle, XCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VerifyCertificatePage = () => {
  const [certificateId, setCertificateId] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResult(null);

    try {
      const res = await axios.get(
        `${API}/certificates/verify/${certificateId}`
      );
      setResult(res.data);
    } catch {
      setResult({ valid: false });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="max-w-xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-bold text-[#0f3e3e] text-center mb-6">
          Verify Certificate
        </h1>

        <Card className="p-6 space-y-4">
          <form onSubmit={handleVerify} className="space-y-4">
            <Input
              placeholder="Enter Certificate ID (e.g. CERT-XXXX)"
              value={certificateId}
              onChange={(e) => setCertificateId(e.target.value)}
              required
            />
            <Button
              className="w-full bg-[#0f3e3e] text-white"
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify Certificate"}
            </Button>
          </form>

          {result && (
            <div className="mt-6">
              {result.valid ? (
                <div className="border border-green-500 bg-green-50 p-4 rounded">
                  <div className="flex items-center gap-2 text-green-700 font-semibold">
                    <CheckCircle />
                    Certificate is Valid
                  </div>

                  <div className="mt-3 text-sm space-y-1">
                    <p><strong>Student Name:</strong> {result.student_name}</p>
                    <p><strong>Course:</strong> {result.course_title}</p>
                    <p>
                      <strong>Issued On:</strong>{" "}
                      {new Date(result.issued_at).toDateString()}
                    </p>
                  </div>
                </div>
              ) : (
                <div className="border border-red-500 bg-red-50 p-4 rounded">
                  <div className="flex items-center gap-2 text-red-700 font-semibold">
                    <XCircle />
                    Invalid Certificate
                  </div>
                  <p className="text-sm mt-2">
                    Certificate ID not found in our records.
                  </p>
                </div>
              )}
            </div>
          )}
        </Card>
      </div>
    </div>
  );
};

export default VerifyCertificatePage;
